import type { FC, HTMLAttributes } from 'react';

import { NavBurgerConnected } from '../navBurger/NavBurgerConnected';
import { ChatControlConnected } from '../navControls/chatControl';
import { FullScreenControlConnected } from '../navControls/fullScreenControl';
import { HelpControlConnected } from '../navControls/helpControl';
import { HistoryControlConnected } from '../navControls/historyControl';
import { LiveSupportControlConnected } from '../navControls/liveSupportControl';
import { LobbyControlConnected } from '../navControls/lobbyControl';
import { QuickGuideControlConnected } from '../navControls/quickGuideControl';
import { SettingsControlConnected } from '../navControls/settingsControl';
import { StreamControlConnected } from '../navControls/streamControl';
import { VolumeSliderControlConnected } from '../navControls/volumeSliderControl';
import { NavDrawerConnected } from '../navDrawer';

import styles from './Nav.module.css';

export interface HeaderNavProps extends HTMLAttributes<HTMLDivElement> {}

export const NavConnected: FC<HeaderNavProps> = () => {
  return (
    <>
      <div className={styles.nav}>
        <NavBurgerConnected />
        <div className={styles.nav__row}>
          <LobbyControlConnected />
          <QuickGuideControlConnected />
          <ChatControlConnected />
          <LiveSupportControlConnected />
          <HistoryControlConnected />
          <HelpControlConnected />
          <span className={styles.nav__rowVolumeControl}>
            <VolumeSliderControlConnected />
          </span>
          <SettingsControlConnected />
          <StreamControlConnected />
          <FullScreenControlConnected />
        </div>
      </div>

      <NavDrawerConnected />
    </>
  );
};
